import Link from "components/common/LinkButton";
import { useHistory } from "react-router-dom";
import * as path from "shared/constants/RoutePathConstants";

export default function SignInInstructionToDownloadExample() {
  const history = useHistory();

  const handleSignInBtnClick = () => {
    history.push(path.SIGN_IN);
  };
  
  return (
    <>
      Please{" "}
      <Link className="text-primaryRed" onClick={handleSignInBtnClick}>
        sign-in
      </Link>{" "}
      to download.
    </>
  );
}
